import { ReviewImage } from '@/fo/ui/review/gallery/base';

export enum ReviewTab {
  Reviews = 'reviews',
  Questions = 'questions'
}

export interface Product {
  id: string;
  title: string;
  volume?: string | string[];
  imageUrl?: string;
  url?: string;
  isNewProduct?: boolean;
}

export interface ReviewResponse {
  text: string;
  recommendedProduct?: Product;
}

export enum ReviewService {
  Otzovik = 'otzovik',
  IRecommend = 'irecommend',
  Ozon = 'ozon',
  Wildberries = 'wildberries',
  YandexMarket = 'yandexMarket'
}

export interface Author {
  name: string;
  age?: number | null;
  skinType?: string | null;
  influencer?: boolean;
}

export interface Review {
  id: string;
  rating: number;
  date: string;
  author: Author;
  pros: string | null;
  cons: string | null;
  comment: string | null;
  showMoreLink?: string | null;
  images: ReviewImage[];
  service?: ReviewService;
  source?: {
    type: ReviewService;
    url: string;
  };
  response?: ReviewResponse;
}

export interface Question {
  id: string;
  date: string;
  author: Author;
  question: string;
  response?: ReviewResponse;
}

export interface ReviewsData {
  totalCount: number;
  rating: number;
  recommendPercent: number;
  images: ReviewImage[];
  items: Review[];
  ratingDetails: RatingDetails;
}

export interface QuestionsData {
  items: Question[];
  totalCount: number;
}

export type RatingFilter = '1' | '2' | '3' | '4' | '5';

export type RatingDetails = Record<RatingFilter, number>;

export enum TagFilter {
  WithPhoto = 'withPhoto',
  Naos = 'naos',
  Otzovik = 'otzovik',
  IRecommend = 'irecommend',
  Ozon = 'ozon',
  Wildberries = 'wildberries',
  YandexMarket = 'yandexMarket'
}

export interface ReviewsFilter {
  selectedRating: RatingFilter | null;
  selectedTags: TagFilter[];
}

export enum SortType {
  Oldest = 'oldest',
  Newest = 'newest'
}
